<template>
  <div>
    <v-card class="pa-3">
      <v-layout wrap class="form-control">
        <v-flex xs6 class="pt-1">
          <div class="primary--text">{{ $t('advanced search') }}</div>
        </v-flex>
        <v-flex xs6 class="text-xs-right">
          <v-btn flat icon @click="$emit('close')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs12>
          <div class="caption">รหัสศูนย์</div>
          <input v-model="filter.branch_id" type="text" />
        </v-flex>
        <v-flex xs12>
          <div class="caption">ชื่อศูนย์</div>
          <input v-model="filter.branch_name" type="text" />
        </v-flex>
        <v-flex xs12>
          <div class="caption">สาขา</div>
          <input v-model="filter.affiliation" type="text" />
        </v-flex>
        <v-flex xs12>
          <div class="caption">จังหวัด</div>
          <input v-model="filter.province" type="text" />
        </v-flex>
        <v-flex xs12 class="pt-3">
          <div class="text-xs-center">
            <v-btn color="grey" outline @click="clearSearch">{{ $t('Clear Search') }}</v-btn>
            <v-btn color="primary" @click="onSearch">{{ $t('Search') }}</v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
const initialFilter = {
  branch_id: '',
  branch_name: '',
  affiliation: '',
  province: ''
}
export default {
  components: {
    Multiselect
  },
  data() {
    return {
      filter: { ...initialFilter }
    }
  },
  methods: {
    clearSearch() {
      this.filter = { ...initialFilter }
      this.$emit('onSearch', this.filter)
    },
    onSearch() {
      this.$emit('onSearch', this.filter)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/YasaleAc/SearchBranchDialog.vue